import BaseModelAPI from '../BaseModelAPI';

export default class BloodTypeList extends BaseModelAPI {

	static entity = 'bloodtypelist'
	static entityName = 'bloodtype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
